module.exports = __webpack_public_path__ + "static/img/home01.44035d45.png";